import { memo } from 'react';
import './link.less';
import { isKim, isMobile } from '@/utils/user-agent';
import { isHttpOrHttpsUrl } from '@src/utils/url';

interface LinkProps {
  node: any;
}

const Link = memo(({ node }: LinkProps) => {
  if (node.href === 'blinkingDot')
    return <span className="blinking-dot"></span>;
  const newHref =
    node.href === 'javascript:void(0)' ? node.properties?.href : node.href;

  const isKimLink = isKim && newHref?.startsWith('kim://');
  const isHttpOrHttpsLink = isHttpOrHttpsUrl(newHref as string);
  const href =
    isHttpOrHttpsLink || isKimLink ? (newHref as string) : 'javascript:void(0)';
  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isMobile && isKim && href !== 'javascript:void(0)') {
      e.preventDefault();
      e.stopPropagation();
      const { kimBridge } = await import('@src/utils/kim-bridge');
      await kimBridge.openWebview(href);
      return;
    }
  };
  // 如果isKim为true，判断 href 是不是以 kim:// 开头，如果是则判断为 true
  return (
    <a
      href={href}
      target={isKimLink || !isHttpOrHttpsLink ? undefined : '_blank'}
      rel={isKimLink || !isHttpOrHttpsLink ? undefined : 'noreferrer'}
      onClick={handleClick}
    >
      {node.children}
    </a>
  );
});
export default Link;
